import { animated, useTransition } from "@react-spring/web";
import { useState } from "react";
import { AspectRatio } from "react-aspect-ratio";
import bg1 from "./LO-1.jpg";
import bg2 from "./LO-2.jpg";
import bg3 from "./LO-3.jpg";

import "./Showcase.css";

const slides = [bg1, bg2, bg3];

const ShowcaseSection = () => {
  const [index, set] = useState(0);
  const transitions = useTransition(index, {
    key: index,
    initial: { opacity: 0.99 },
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    config: { duration: 600 },
    delay: 3000,
    onRest: (_a, _b, item) => {
      if (index === item) {
        set((state) => (state + 1) % slides.length);
      }
    },
  });

  return (
    <section className="section-showcase relative flex flex-col justify-center items-center h-full">
      <div className="text-overlay md:absolute">
        <h2
          className="text-1 text-center font-light md:font-medium"
          style={{
            filter: "drop-shadow(6.472px 4.702px 4px rgba(21,21,21,0.52))",
          }}
        >
          พัดลม Mitsubishi Electric
        </h2>
        <h3
          className="text-2 text-center font-medium md:font-light"
          style={{
            filter: "drop-shadow(6.472px 4.702px 4px rgba(21,21,21,0.52))",
          }}
        >
          เหมาะสำหรับ<span className="block md:inline">ทุกห้องในบ้าน</span>
        </h3>
      </div>
      <AspectRatio ratio="1920/890" style={{ width: "100%" }}>
        {transitions((style, i) => (
          <animated.div
            className="slide absolute top-0 left-0 w-full h-full"
            style={{
              ...style,
              backgroundImage: `url(${slides[i]})`,
            }}
          />
        ))}
      </AspectRatio>
    </section>
  );
};

export default ShowcaseSection;
